// El tamaño en la hoja de vista previa (04-11-2026). «Ajustar» = la página (o la imagen) cabe a lo ancho; un número es el
// tamaño real en %: 100 % es el PDF a su tamaño de papel en pantalla (1 pt = 96/72 px, como Vista Previa y pdf.js) o la
// imagen a sus píxeles. Con + y − se va por los mismos escalones que Vista Previa; Ctrl+rueda y el pellizco, continuo.
export type Zoom = 'ajustar' | number;

export const MINIMO = 25;
export const MAXIMO = 400;
export const ESCALONES: readonly number[] = [MINIMO, 33, 50, 67, 75, 90, 100, 110, 125, 150, 175, 200, 250, 300, MAXIMO];

/** Un PDF: px de pantalla por punto de papel al 100 %. */
export const PX_POR_PUNTO = 96 / 72;

export const acotar = (z: number): number => Math.min(MAXIMO, Math.max(MINIMO, z));

/** El % que tiene ahora la vista (con «Ajustar», el que resulta de ajustar). */
export const efectivo = (z: Zoom, ajuste: number): number => (z === 'ajustar' ? ajuste : z);

/** El escalón siguiente por encima del tamaño actual. */
export function acercar(z: Zoom, ajuste: number): number {
  const e = efectivo(z, ajuste);
  return ESCALONES.find((s) => s > e * 1.01) ?? MAXIMO;
}

/** El escalón anterior por debajo del tamaño actual. */
export function alejar(z: Zoom, ajuste: number): number {
  const e = efectivo(z, ajuste);
  return [...ESCALONES].reverse().find((s) => s < e * 0.99) ?? MINIMO;
}

/** Ctrl+rueda / pellizco: multiplica el tamaño actual (sin escalones), dentro de los topes. */
export const multiplicar = (z: Zoom, ajuste: number, factor: number): number => Math.round(acotar(efectivo(z, ajuste) * factor) * 10) / 10;

/** El texto del botón del medio: «Ajustar» o «125 %». */
export const etiquetaZoom = (z: Zoom, ajustar: string): string => (z === 'ajustar' ? ajustar : `${Math.round(z)} %`);
